// TODO get rid of jquery dependecy
import jquery from 'jquery'
window.jQuery = jquery
window.$ = jquery
